import {Coins} from "lucide-react";
import SteddiInfoItem from "../../General/SteddiInfoItem";
import useOrderState from "../../../stores/orderStore";

export default function Månedsbeløp({color, override, noShake}: { color?: string, override?: number, noShake?: boolean }) {
  const price = useOrderState((state) => state.priceEstimate)
  const state = useOrderState((state) => state)
  const steddiPrices = useOrderState((state) => state.steddiPrices)

  return (
    <div className={noShake ? "" : "shakeMe"}>
      <SteddiInfoItem title={"Månedsbeløpet ditt nå"}
                      subtitle={price || override ? `${override ? override.toLocaleString() : price!.toLocaleString()} kr (inkl. prisen på ${steddiPrices?.steddiPrice} kr)` : "Ukjent"}
                      isLoading={state.estimateLoading} icon={<Coins/>} bgColor={color ?? "secondary"}/>
    </div>
  )
}